import { makeStyles } from '@mui/styles';

export const useVerifiedButtonStyles = makeStyles(() => {
  return {
    icon: {
      color: 'green',
    },
  };
});
